import { toast } from "sonner";

/** Cross-environment safe clipboard copy with fallback + correct toast timing. */
export async function copyToClipboard(text, successMsg = "Copied") {
  if (!text) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      toast.success(successMsg);
      return true;
    }
  } catch {
    // fall through to legacy path
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.focus(); ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    if (ok) { toast.success(successMsg); return true; }
  } catch {
    /* ignore */
  }
  toast.error("Copy not allowed — please copy manually.");
  return false;
}
